import { render } from "./TopNavigation.vue?vue&type=template&id=d3d8619c&scoped=true"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=d3d8619c&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/vueApps/ronchipiero.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d8619c"]])

export default __exports__